/* eslint-disable max-len */

const SELF_STORAGE_DATA = [
	{
		heading: "Self storage: search and rent online at storage.com",
		description:
			"Storage.com allows you to search thousands of self storage facilities with one click. Simply enter in a location (state, city, address or zip) into the search box and find self storage units available for rent. You can compare self storage facilities by location, size, features as well as pricing, making find the perfect self storage unit for your needs much easier.",
		description2:
			'In addition, Storage.com has partnered with various self storage locations, offering you the best price storage units. Look for the "Web Only Special" rate listed for each size self storage unit if available.'
	},
	{
		heading: "What Size Self Storage",
		description:
			"Self storage units offered will vary by location, however, there are a few common sizes:",
		points: [
			{ desc: "5' x 5' (approximately 25 square feet)" },
			{ desc: "5' x 10' (approximately 50 square feet)" },
			{ desc: "10' x 10' (approximately 100 square feet)" },
			{ desc: "10' x 15' (approximately 150 square feet)" },
			{ desc: "10' x 20' (approximately 200 square feet)" },
			{ desc: "10' x 30' (approximately 300 square feet)" },
			{ desc: "10' x 30' (approximately 300 square feet)" }
		],
		descriptionWithLink: {
			contentBefore: "To determine the size you need, visit the ",
			linkText: "self storage guide.",
			link: "/self-storage-size-guide"
		}
	},
	{
		heading: "What to Look For in Self Storage",
		description:
			"Choosing self storage is easy, once you identify what will be stored:",
		points: [
			{
				desc: "Large, bulky items—choose a unit with drive-up access"
			},
			{ desc: "Small, delicate items—choose an indoor unit" },
			{
				desc: "Location with extreme temperatures choose a unit that is climate controlled"
			},
			{
				desc: "Items requiring easy or unlimited access to choose a facility that offers 24-hour access"
			}
		]
	},
	{
		heading: "When Do You Need Self Storage",
		description:
			"There may be a number of times to considering using self storage, including:",
		points: [
			{ desc: "Moving/relocating" },
			{
				desc: "Down-sizing current residential or business storage space"
			},
			{
				desc: "Out-growing current residential or business storage space"
			},
			{
				desc: "Storing items not currently in use but planned for later use (i.e. baby furniture)"
			},
			{ desc: "Temporary storage needs" }
		]
	},
	{
		heading: "Search for Self Storage Units",
		description:
			"Storage.com lists self storage locations across 50 states in the US. Please select the city you are interested in from the list of cities with storage.com facilities below.",
		popularCities: true
	},
	{
		heading: "Reserve Self Storage Online",
		description:
			"Storage.com allows visitors to not only view and compare self storage units, you can reserve the unit online. Simply find the self storage unit you would like to rent and click the reserve button. Fill in the required information and confirm and your reservation for the self storage unit will be completed. Simply take a copy of your reservation confirmation to the self storage facility to claim your unit."
	}
];

export { SELF_STORAGE_DATA };
